import { constants } from "@maxgraph/core";
/** Display the maxGraph version in the footer. */
const fillFooter = () => {
    const footer = document.querySelector('footer');
    footer.innerText = `Built with maxGraph ${constants.VERSION}`;
};
export const fillMainContainerInnerHtml = (cssSelector, options) => {
    document.querySelector(cssSelector).innerHTML = `
    <h1>maxGraph <a href="${options.toolUrl}" target="_blank" rel="noopener noreferrer">${options.toolName}</a> TypeScript example</h1>
    <p>Display a test graph. Activated behaviours:</p>
    <ul>
      <li>Panning: use mouse right button</li>
      <li>Cells selection with Rubberband: use mouse left button</li>
    </ul>
    <div id="graph-container"></div>
    <footer></footer>
`;
    fillFooter();
};
//# sourceMappingURL=fill-html-content.js.map